var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"input-range",attrs:{"type":"range","min":_vm.config.min,"max":_vm.config.max,"step":_vm.config.step},domProps:{"value":_vm.value},on:{"input":function($event){_vm.input($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }